<div class="d-flex flex-column h-100">
  <nav class="navbar navbar-expand navbar-main p-0">
    <div class="container-fluid gap-2">
      <a class="navbar-brand d-flex align-items-center gap-3 me-auto" routerLink="/">
        @if (logoUrl$ | async; as logoUrl) {
          <img [src]="logoUrl" height="38" class="d-inline-block" crossorigin="anonymous" alt="logo" />
        }
        <span>{{ brandName$ | async }}</span>
      </a>
      <span>
        <app-switch-back-button></app-switch-back-button>
      </span>
      <span>
        <app-update-software-button></app-update-software-button>
      </span>
      <!-- <span *appIfExpertMode>
      <app-sii-restore-button></app-sii-restore-button>
    </span> -->
      <span>
        <app-save-problem-report-button></app-save-problem-report-button>
      </span>
      <span>
        <app-disconnect-button></app-disconnect-button>
      </span>
    </div>
  </nav>

  <app-release-info></app-release-info>

  <div class="flex-grow-1 overflow-auto">
    <div class="container h-100">
      <div class="row align-items-center justify-content-center h-100">
        <div class="col-8 text-center">
          <img src="assets/images/issues/{{ issue.image }}" alt="issue" height="64px" />
          <h4 class="mt-4 mb-0">{{ issue.title }}</h4>
          <p [innerHtml]="issue.body"></p>
          @if (isOblacDrivesBrand$ | async) {
            <div>
              <a
                href="https://www.synapticon.com/documentation/oblac/oblac/trouble_shooting.html"
                target="_blank"
                rel="noreferrer noopener"
                class="btn btn-outline-primary mb-3"
              >
                TROUBLESHOOTING GUIDE
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <app-main-statusbar></app-main-statusbar>
</div>
